import { FeatureFlag } from '@/enums/feature-flag';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useFeatureFlagsReady } from '@/hooks/use-feature-flags-ready';

export function useMcpTesterVisible() {
  const isReady = useFeatureFlagsReady();
  const hasMcpTester = useFeatureFlag(FeatureFlag.MCP_SERVER_TESTER);

  return isReady && hasMcpTester;
}
